import {
  Provider
} from "./chunk-NAQNA6DI.mjs";

// src/react/SaleorAuthProvider.tsx
import { jsx } from "react/jsx-runtime";
var SaleorAuthProvider = ({ children, client }) => {
  return /* @__PURE__ */ jsx(Provider, { value: client, children });
};

export {
  SaleorAuthProvider
};
